/* ================================================================
   TARASHE — About Us Page JS
   File: assets/tarashe-about.js
   Parallax, scroll animations, progress bar
================================================================ */

(function () {
  'use strict';

  /* ── Reduced motion check ── */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll progress bar ── */
  var progressBar = document.querySelector('.ta-progress-bar');

  function updateProgress() {
    if (!progressBar) return;
    var scrollTop  = window.scrollY || document.documentElement.scrollTop;
    var docHeight  = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var progress   = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressBar.style.width = progress.toFixed(1) + '%';
  }

  /* ── IntersectionObserver — scroll animations ── */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('[data-animate]');
    if (!elements.length) return;

    /* If reduced motion, make all visible immediately */
    if (prefersReduced) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -48px 0px'
    });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ── Parallax ── */
  var parallaxWrappers = [];
  var isMobile = window.innerWidth <= 749;
  var rafId    = null;
  var lastScroll = -1;

  function collectParallax() {
    parallaxWrappers = Array.from(
      document.querySelectorAll('.about-story__parallax-wrap')
    ).map(function (wrap) {
      return {
        el:  wrap,
        col: wrap.closest('.about-story__image-col')
      };
    }).filter(function (item) { return item.col; });
  }

  function computeParallax() {
    if (isMobile || prefersReduced || !parallaxWrappers.length) return;

    var scrollY = window.scrollY || window.pageYOffset;
    if (Math.abs(scrollY - lastScroll) < 1) return;
    lastScroll = scrollY;

    var vh = window.innerHeight;

    parallaxWrappers.forEach(function (item) {
      var rect = item.col.getBoundingClientRect();
      /* Only compute when visible */
      if (rect.bottom < -vh || rect.top > vh * 2) return;

      /* Map center of element through viewport to a -1 → 1 range */
      var center   = rect.top + rect.height / 2;
      var progress = (vh / 2 - center) / (vh / 2 + rect.height / 2);
      /* Clamp and apply subtle shift — max ±24px */
      var shift = Math.max(-1, Math.min(1, progress)) * 24;
      item.el.style.transform = 'translateY(' + shift.toFixed(2) + 'px)';
    });
  }

  function onScroll() {
    updateProgress();
    if (!prefersReduced) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(computeParallax);
    }
  }

  /* ── Promise section parallax ── */
  var promiseBg = document.querySelector('.ta-promise__bg');

  function computePromiseParallax() {
    if (!promiseBg || isMobile || prefersReduced) return;
    var rect = promiseBg.closest('.ta-promise');
    if (!rect) return;
    var bounds = rect.getBoundingClientRect();
    var vh = window.innerHeight;
    if (bounds.bottom < 0 || bounds.top > vh) return;
    var progress = (vh / 2 - (bounds.top + bounds.height / 2)) / vh;
    promiseBg.style.transform = 'translateY(' + (progress * 30).toFixed(2) + 'px)';
  }

  /* ── Image reveal animation ── */
  function initImageReveals() {
    var reveals = document.querySelectorAll('.about-story__image-reveal');
    if (!reveals.length || prefersReduced) {
      reveals.forEach(function (r) { r.style.display = 'none'; });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.style.transition = 'transform 1s cubic-bezier(0.76,0,0.24,1)';
          el.style.transform   = 'scaleY(0)';
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.05 });

    reveals.forEach(function (r) { observer.observe(r); });
  }

  /* ── Values items — stagger on reveal ── */
  function initValuesStagger() {
    var items = document.querySelectorAll('.ta-values__item');
    if (!items.length) return;

    if (prefersReduced) {
      items.forEach(function (el) { el.style.opacity = '1'; });
      return;
    }

    items.forEach(function (el, i) {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      el.style.transitionDelay = (i * 0.08) + 's';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var grid = entry.target;
          grid.querySelectorAll('.ta-values__item').forEach(function (el) {
            el.style.opacity = '1';
            el.style.transform = 'none';
          });
          observer.unobserve(grid);
        }
      });
    }, { threshold: 0.1 });

    var grid = document.querySelector('.ta-values__grid');
    if (grid) observer.observe(grid);
  }

  /* ── Resize ── */
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      isMobile = window.innerWidth <= 749;
      if (isMobile) {
        parallaxWrappers.forEach(function (item) {
          item.el.style.transform = 'none';
        });
      }
    }, 150);
  }

  /* ── Init ── */
  function init() {
    collectParallax();
    initScrollAnimations();
    initImageReveals();
    initValuesStagger();
    updateProgress();
    computeParallax();
    computePromiseParallax();
  }

  /* Combine scroll handlers */
  window.addEventListener('scroll', function () {
    onScroll();
    computePromiseParallax();
  }, { passive: true });

  window.addEventListener('resize', onResize, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.about-story')) {
      collectParallax();
      initScrollAnimations();
      initImageReveals();
      initValuesStagger();
    }
  });

})(); 